module.exports = __webpack_public_path__ + "static/media/3.jpg.591106ac.webp";